module.exports = __webpack_public_path__ + "static/img2f-7e5439e7472e0a2ab8b7eea28b39a8a5.jpg";